import { memo, useMemo } from 'react'

import { Grid } from '@mui/material'

import hash from 'object-hash'

import { getMetricsPositionStorageKey } from '@common/components/MetricsSelector/utils'
import { useLocalStorage } from '@common/utils'
import { getDefaultMetricsPositions } from '@common/utils/metricsUtils'
import metrics from '@portal/pages/Dashboards/SmokeMetrics/metrics'

import EntityCard from '../EntityCard'

/**
 * @component
 * @param {Object} props - The props for the component.
 * @param {Object} props.groupedByEntityData
 * @param {Object} props.selectedMetrics
 */
const GroupedByEntityView = memo(({ groupedByEntityData, selectedMetrics }) => {
  const [metricsPositions] = useLocalStorage(
    getMetricsPositionStorageKey(),
    getDefaultMetricsPositions(metrics),
  )

  const sortFn = (a, b) => {
    const aPosition = metricsPositions[a.metric] ?? 99
    const bPosition = metricsPositions[b.metric] ?? 99
    return aPosition > bPosition ? 1 : -1
  }

  const sortedData = useMemo(
    () =>
      Object.entries(groupedByEntityData).reduce(
        (acc, [key, value]) => ({ ...acc, [key]: value.sort(sortFn) }),
        {},
      ),
    [groupedByEntityData, metricsPositions],
  )
  const sortedDataHash = useMemo(() => hash(sortedData), [sortedData])

  return Object.entries(sortedData).map(([key, data]) => (
    <Grid key={`${key}_${sortedDataHash}`} size={{ xll: 6, sm: 12 }}>
      <EntityCard dataKey={key} selectedMetrics={selectedMetrics} data={data} />
    </Grid>
  ))
})

export default GroupedByEntityView
